import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initProduct } from '../scripts/product';
import CtaSection from '../components/CtaSection';
import ProductHero from './product/ProductHero';
import SectionNav from './product/SectionNav';
import PortalSection from './product/PortalSection';
import KnowledgeSection from './product/KnowledgeSection';
import WorkflowSection from './product/WorkflowSection';
import RagSection from './product/RagSection';
import LibrarySection from './product/LibrarySection';
import AdminSection from './product/AdminSection';

/** 제품소개(기능소개) 페이지. 섹션 #s1~#s6 는 헤더 드롭다운에서 앵커로 이동 */
export default function ProductPage() {
  const rootRef = useRef<HTMLDivElement>(null);
  const { hash } = useLocation();

  useEffect(() => {
    document.title = 'AcXion-On 제품소개';
    return rootRef.current ? initProduct(rootRef.current) : undefined;
  }, []);

  // 헤더 드롭다운(/product#s2 등)으로 들어오면 해당 섹션으로 스크롤
  useEffect(() => {
    if (!hash) return;
    const timer = window.setTimeout(() => {
      const el = rootRef.current?.querySelector(hash);
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
    }, 50);
    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <div className="pg-product" ref={rootRef}>
      <ProductHero />
      <SectionNav />
      <PortalSection />
      <KnowledgeSection />
      <WorkflowSection />
      <RagSection />
      <LibrarySection />
      <AdminSection />
      <CtaSection reveal="pd-rv" />
    </div>
  );
}
